import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  selector: 'ups-dynamic-textarea',
  styleUrls: ['dynamic-textarea.component.scss'],
  template: `
    <div class="dynamic-field-container" [class.selected]="config?.selected">
      <div
        class="dynamic-field form-input text-align"
        [formGroup]="group"
        [hidden]="!config?.isFormBuilder && config?.options?.hidden"
      >
        <ups-dynamic-helper-label
          [config]="config"
          [dynamicService]="dynamicService"
        ></ups-dynamic-helper-label>

        @if (disableItem) {
          <p
            style="border: 1px solid #d6d8df; border-radius: 4px; padding: 10px; min-height: 50px;"
          >
            {{ config.value }}
          </p>
        }
        @if (!disableItem) {
          <textarea
            class="k-textarea"
            [attr.name]="config.formControlName"
            [attr.placeholder]="config?.placeholder"
            [formControlName]="config.formControlName"
            [attr.maxLength]="
              config?.options?.maxlength ? config?.options?.maxlength : null
            "
            rows="4"
          ></textarea>
        }
        @if (config?.isFormBuilder) {
          <div
            class="form-builder-mask"
            [class.hidden]="config?.options?.hidden"
          ></div>
        }
      </div>
      @if (config?.isFormBuilder) {
        <div class="form-builder-options">
          <i
            class="fas fa-times ml-3 cursor-pointer c-red"
            (click)="delete()"
          ></i>
          <!-- <i class="fas fa-bars ml-3 cursor-grab"></i> -->
        </div>
      }
    </div>
  `,
  // WI 35584: base-class marks cover async writes; ngDoCheck covers in-place config flags.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicTextareaComponent extends DynamicItemBaseComponent {}
